import React from 'react'
import { Link } from "react-router-dom";

export default function HomeBanner() {
  return (
    <>
    <section className="banner-section">
       <div className="homebanner-text">
            <h1 className='heading'>India's Leading Couturier</h1>
            <p>Timeless Glamour</p>
            <Link to={"/wedding-dress-designers"} className="default-btn">discover Now</Link>
            <Link to={"/wedding-dress-designers"} className="default-btn red-default">Explore</Link>
        </div>

        <img src="/image/banner-1.webp" className="img-responsive" alt="banner"/>
        <div className="banner-overlay"></div>
    </section> 
    </>
  )
}
